import * as React from 'react';
import { VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from './PFTAPITypes';
import Loading, { FontSize } from '../../misc/components/loading';
import { IsDefined } from '../../Core/Comparison';

export interface ResultProps {
    parameter: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter;
    isLoading?: boolean;
}

const Result = ({ parameter, isLoading }: ResultProps): JSX.Element => {
    let emptyValue: string = '-';

    if (isLoading) {
        return (
            <Loading className={"text-left text-info"} size={FontSize.OneX} />
        );
    }

    return (
        <>{
            IsDefined(parameter) && IsDefined(parameter.RoundedValue) && (!parameter.ShowPositiveValueOnly || parameter.RoundedValue >= 0)
                ? parameter.RoundedValue.toFixed(parameter.DecimalPlaces)
                : emptyValue }</>
    );
}

export default Result;
